import type { ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'
import type { IASOKeyword } from '~/types/aso'

import './style.scss'

const ASOTitleCellRenderer = ({ data }: ICellRendererParams<IASOKeyword>): ReactElement => {
  if (!data) return <div />

  const { subtitle, title } = data

  return (
    <div className="aso-title-cell-renderer-container">
      <div className="title">{title}</div>
      <div className="subtitle">{subtitle}</div>
    </div>
  )
}

export default ASOTitleCellRenderer
